// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const isAuthenticated = Boolean(localStorage.getItem("email"));
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/applicant-login"
        replace
        state={{ from: location }}
      />
    );
  }
  return children;
}
